import { render, staticRenderFns } from "./MonthlyTaxHSBC.vue?vue&type=template&id=08362fc2"
import script from "./MonthlyTaxHSBC.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxHSBC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports